// extracted by mini-css-extract-plugin
module.exports = {"description":"_22MDLy","inspiration":"_7c8Z5X","paragraph":"hnynVQ","preamble":"_232mjF","inspiration_big":"_2lLURa","base":"cg_6sV","h3":"_3XpLxs"};